import { Api, IApiResponse } from '../api';
import { ProfileDefaultAppsDto } from '../models';

export const getMany = (): Promise<IApiResponse<ProfileDefaultAppsDto[]>> => Api.get('profile-default-apps');

export const updateMany = (profileDefaultApps: ProfileDefaultAppsDto[]) => Api.put('profile-default-apps', profileDefaultApps);
